import React, { useState } from "react";
import SEO from "../components/seo";
import Layout from "../components/layout";
import FreiexemplarForm from "../components/forms/freiexemplar/form";
import MakroAlert, { MakroAlertType } from "../components/common/alert";
import freiexemplar from "../images/freiexemplar.png";
import { orderFreiexemplar } from "../services/monsum/freiexemplar/order";
const FreiexemplarPage = () => {
    const { 0: orderState, 1: setOrderState } = useState("NONE");
    const onSubmit = (values, _ref) => {
        let { setSubmitting } = _ref;
        setSubmitting(true);
        const orderData = {
            email: values.customer.email,
            salutation: values.customer.salutation,
            firstName: values.customer.firstName,
            lastName: values.customer.lastName,
            street: values.customer.street,
            zipcode: values.customer.postalCode,
            city: values.customer.city,
            country: values.customer.country,
            agb: values.legal.agb,
            privacy: values.legal.privacy
        };
        orderFreiexemplar(orderData, values.newsletter.newsletter).then(result => {
            // @ts-ignore
            if (result.success) {
                onSubmitSuccess();
            }
            else {
                onSubmitError();
            }
        }).catch(err => {
            console.error(err);
            onSubmitError();
        });
        const onSubmitSuccess = () => {
            setOrderState("SUCCESS");
            setSubmitting(false);
        };
        const onSubmitError = () => {
            setOrderState("ERROR");
            setSubmitting(false);
        };
    };
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Freiexemplar"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full border-t-8 border-solid border-makroOrange lg:w-2/3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, "Kostenloses Themenheft"), /*#__PURE__*/ React.createElement("div", {
        className: "pb-8 px-3 lg:px-8 hidden"
    }, "Aktion beendet."), /*#__PURE__*/ React.createElement("div", {
        className: "pb-8 px-3 lg:px-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-lg mt-4 mb-12"
    }, "Bestellen Sie ein kostenloses Exemplar unseres Themenhefts zur Bundetagswahl 2021 ", /*#__PURE__*/ React.createElement("strong", null, "\xBBWahlprogramm sucht Partei\xAB"), "."), orderState == "NONE" && /*#__PURE__*/ React.createElement(FreiexemplarForm, {
        onSubmit: onSubmit
    }), orderState == "ERROR" && /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.DANGER,
        title: "Das hat leider nicht geklappt",
        text: /*#__PURE__*/ React.createElement("span", null, "Bitte versuchen Sie es erneut oder wenden Sie sich an ", /*#__PURE__*/ React.createElement("a", {
            href: "mailto:aboservice@makroskop.eu",
            className: "underline"
        }, "aboservice@makroskop.eu"), ".")
    }), orderState == "SUCCESS" && /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.SUCCESS,
        title: "Bestellung erfoglreich",
        text: "Sie haben das Freiexemplar erfogreich bestellt."
    }), /*#__PURE__*/ React.createElement("div", {
        className: "mt-16 flex justify-center"
    }, /*#__PURE__*/ React.createElement("img", {
        src: freiexemplar,
        alt: "Themenheft >>Wahlprogramm sucht Partei<<",
        style: {
            maxWidth: "480px"
        }
    }))))));
};
export default FreiexemplarPage;
